import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// import Backend from 'i18next-http-backend';

// ** utils Import
import { getDefaultLanguage } from "../utils";

// ** Import Files translations
import translationAR from "../assets/data/locales/ar.json";
import translationEN from "../assets/data/locales/en.json";

// the translations
const resources = {
  ar: {
    translation: translationAR,
  },
  en: {
    translation: translationEN,
  },
};

i18n
  //   // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  //   // learn more: https://github.com/i18next/i18next-http-backend
  //.use(Backend)
  //   // detect user language
  //   // learn more: https://github.com/i18next/i18next-browser-languageDetector
  //   //   .use(LanguageDetector)
  //   // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // if you're using a language detector, do not define the lng option read :
    lng: getDefaultLanguage().lang,
    fallbackLng: ["ar"],
    resources,
    //   returnObjects: false,
    // joinArrays: false,
    debug: true, // change it this to false in production

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });
// i18n.t('arrayJoin', { joinArrays: '+' });
export default i18n;
